import SeshAccordian from "../sesh_accordian";
import React from "react";
import { EventCreationInputKeys } from "../../event_creation";
import { PollCreationInputKeys } from "../../poll_creation";
import { ImageUploaderForm } from "../image_uploader";

export default function ImageUploaderAccordian(props: {
	field_key: EventCreationInputKeys | PollCreationInputKeys;
	is_premium: boolean;
	image_url: string;
	disabled?: boolean;
	info: string;
	updateFunc: (value: string) => void;
}) {
	return (
		<SeshAccordian
			field_key={props.field_key}
			is_server_premium={props.is_premium}
			label="Image"
			initial_value={props.image_url}
			opened_initially={Boolean(props.image_url)}
			info={props.info}
			disabled={props.disabled}
			onCheckboxUnclicked={() => props.updateFunc(null)}
			render_child={(field_key, initial_value) => {
				return (
					<ImageUploaderForm
						updateFunc={(val) => props.updateFunc(val)}
						initial_value={initial_value}
					></ImageUploaderForm>
				);
			}}
		></SeshAccordian>
	);
}
